import React, { Component } from 'react';
import TextButton from 'components/TextButton';
import './Scrollable.css';

const SCROLL_STEP = 40;

class ScrollableWithArrows extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parentHeight: 0,
      height: 0,
      top: false,
      showTopArrow: false,
      showBottomArrow: false
    };
    this.nodeRef = React.createRef();
    this.innerRef = React.createRef();
  }

  setTop(state) {
    if (state.height) {
      // dimension changed
      if (state.height > state.parentHeight) {
        if (this.state.top === false) {
          state.top = 0;
          state.showTopArrow = false;
          state.showBottomArrow = true;
        }
      } else {
        state.top = false;
        state.showTopArrow = false;
        state.showBottomArrow = false;
      }
    }

    if (state.top !== false && state.top !== undefined) {
      if (state.top >= 0) {
        state.top = 0;
        state.showTopArrow = false;
        state.showBottomArrow = true;
      } else {
        state.showTopArrow = true;
        const height = state.height || this.state.height;
        const parentHeight = state.parentHeight || this.state.parentHeight;
        if (parentHeight - state.top >= height) {
          state.showBottomArrow = false;
          state.top = parentHeight - height;
        } else {
          state.showBottomArrow = true;
        }
      }
    }

    this.setState(state);
  }

  onClickTop(e) {
    this.setTop({ top: this.state.top + SCROLL_STEP });
    e.stopPropagation();
  }
  onClickBottom(e) {
    this.setTop({ top: this.state.top - SCROLL_STEP });
    e.stopPropagation();
  }
  onWeel(e) {
    if (this.state.top !== false) {
      const delta = e.deltaY < 0 ? SCROLL_STEP : -SCROLL_STEP;
      this.setTop({ top: this.state.top + delta });
    }
    e.stopPropagation();
  }

  componentDidMount() {
    const node = this.nodeRef.current;
    const inner = this.innerRef.current;

    this.setTop({
      height: inner.clientHeight,
      parentHeight: node.clientHeight
    });

    // TODO Switch to addEventListener so it doesn't overwrite the window onresize handler
    // TODO Clear handler on unmount
    window.onresize = () => {
      this.setTop({
        height: inner.clientHeight,
        parentHeight: node.clientHeight
      });

      // console.log(
      //   'ScrollableWithArrows, window.onresize, my height:',
      //   inner.clientHeight,
      //   'parents height',
      //   node.clientHeight
      // );
    };

    // console.log(
    //   'ScrollableWithArrows.componentDidMount, my height:',
    //   inner.clientHeight,
    //   'parents height',
    //   node.clientHeight
    // );
  }

  render() {
    const { top, showTopArrow, showBottomArrow } = this.state;
    const style =
      top === false
        ? {
            position: 'unset',
            top: 'auto'
          }
        : {
            position: 'absolute',
            top: top + 'px'
          };
    return (
      <div className={this.props.className} ref={this.nodeRef}>
        <div
          className="scroll-wrapper"
          style={style}
          onWheel={e => this.onWeel(e)}
          ref={this.innerRef}
        >
          {this.props.children}
        </div>
        {showTopArrow && (
          <TextButton
            className="scroll-top-arrow"
            onClick={e => this.onClickTop(e)}
            aria-hidden="true"
          />
        )}
        {showBottomArrow && (
          <TextButton
            className="scroll-bottom-arrow"
            onClick={e => this.onClickBottom(e)}
            aria-hidden="true"
          />
        )}
      </div>
    );
  }
}

export default ScrollableWithArrows;
